import Axios from 'axios';
import {downloadExcel, downloadExcelASIS, getApiHost} from "../utils";


const axios = Axios.create({
  responseType: "json"
});

export const getUserAddress = () => {
  // 일자리맵 - 사용자의 접속지역을 기준으로 접속시 해당 지역으로 줌레벨 확대
  return axios.post('http://ip-api.com/json');
};

export const getGeojsonUrlList = async ({latitude, longitude, zoom, visibleRadius, apiUrl, extraParams = {}}) => {
  const params = {latitude, longitude, zoom, visibleRadius, ...extraParams};
  const response = await axios.get(apiUrl, {params});
  const {data} = response;
  return data;
};


export const getListByUidArray = ({
                                    relUrl, uidArray, isExcelDownload = false, excelFileName = 'export.xls',
                                    curPage = 1, pageSize = 20,
                                    uidsAll,
                                  }) => {
  // 와이파이 분포는 uid 없이 넘어와서 해당 url만 제외하도록 일단 조치했습니다.
  const uid = window.location.pathname === '/gis/wavedata_density.do'
    ? ['0'] : uidArray;
  const url = isExcelDownload ? '/gis/listExcelDown.do' : relUrl;
  const config =
    isExcelDownload ?
      {
        params: {
          excelUrl: window.location.pathname,
          uidsAll: uidsAll,
        },
        responseType: 'blob',
      }
      :
      {
        params: {
          curPage: curPage,
          pageSize: pageSize,
          uidsAll: uidsAll,
        },
      };

  return axios.post(url,
    {
      uid: uid,
    }, config
  ).then(response => {
    if (isExcelDownload) {
      downloadExcel(response, excelFileName);
    }
    return response;
  });
};

export const getListByParameters = ({
                                      relUrl
                                      , currentDistrictCode
                                      , clsCodeStatsList
                                      , serviceCodeStatsList
                                      , isExcelDownload = false
                                      , excelFileName = 'export.xls'
                                      , searchStartYear
                                      , searchEndYear
                                      , innpk_nm
                                      , extraYn
                                    }) => {
  const url = isExcelDownload ? '/gis/listExcelDown.do' : relUrl;
  const config =
    isExcelDownload ?
      {
        params: {
          // /rwdinfolabstats/viewYearBySvcByStats.do
          excelUrl: window.location.pathname,
          // format: 'excel',
        },
        responseType: 'blob',
      } : undefined;

  return axios.post(url,
    {
      district_code: currentDistrictCode,
      cls_code: clsCodeStatsList ? clsCodeStatsList : [],
      service_code: serviceCodeStatsList ? serviceCodeStatsList : [],
      start_year: searchStartYear,
      end_year: searchEndYear,
      innpk_nm: innpk_nm,
      extraYn: extraYn,
    }, config
  ).then(response => {
    if (isExcelDownload) {
      downloadExcel(response, excelFileName);
    }
    return response;
  });
};

export const getListWithSecureZone = ({
                                        relUrl, uidArray, district_code,
                                        isExcelDownload = false, excelFileName = 'export.xls',
                                        curPage = 1, pageSize = 20
                                      }) => {
  const url = isExcelDownload ? '/gis/listExcelDown.do' : relUrl;
  const config =
    isExcelDownload ?
      {
        params: {
          // /rwdinfolabstats/viewYearBySvcByStats.do
          excelUrl: window.location.pathname,
          // format: 'excel',
        },
        responseType: 'blob',
      }
      :
      {
        params: {
          curPage: curPage,
          pageSize: pageSize,
        },
      };

  return axios.post(url,
    {
      uid: uidArray,
      district_code: district_code,
    }, config
  ).then(response => {
    if (isExcelDownload) {
      downloadExcel(response, excelFileName);
    }
    return response;
  });
};

export const getPointByUid = ({relUrl, uidValue, jungon}) => {
  const url = relUrl;
  return axios.post(url,
    {
      uid: [uidValue],
    }, {
      params: {
        jungon: jungon
      }
    });
};

/*
  기존 엑셀 다운로드 기능 사용하는 함수
  사용방법 : formData를 만들어서 그 안에 사용하는 파라미터를 세팅한 후 함께 보냄.
  spring 컨트롤러에서 excelUrl을 확인하여 함께 formData에 포함시켜줘야함.
 */
export const getAsisExcelList = ({formData, excelFileName = 'export.xls', url = '/gis/excelDown.do'}) => {
  // 방송수신정보 라디오정보 가져오는 url = /gis/getbroadcastPagedPopExcel.do

  // const url = '/gis/excelDown.do';
  const hostUrl = getApiHost() + url;
  return axios.post(hostUrl, formData,
    {
      responseType: 'blob',
    },
  ).then(response => {
    downloadExcelASIS(response, excelFileName);
  });
};
